import React from "react"
import styled from "@emotion/styled"

import CapitariaLogoBlack from "../ui/images/capitaria-logo-black"

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 55px 45px 70px;
  background: #fafafa;
  @media (min-width: 736px) {
    padding-top: 52px;
    padding-bottom: 50px;
  }
  @media (min-width: 1024px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
`

const Description = styled.div`
  max-width: 300px;
  text-align: center;
  margin-top: 25px;
  font-size: 16px;
  line-height: 140%;
  @media (min-width: 736px) {
    max-width: 420px;
  }
  @media (min-width: 1024px) {
    margin-top: 30px;
    max-width: 575px;
  }
`

const DescriptionCapitaria = () => {
  return (
    <TextContainer>
      <div>
        <CapitariaLogoBlack />
      </div>
      <Description>
        Estamos en la misión de empoderar a las personas para que tomen el
        control de sus inversiones entregándoles educación constante,
        información oportuna y una plataforma para que en un click puedan
        acceder a los mercados del mundo.
      </Description>
    </TextContainer>
  )
}

export default DescriptionCapitaria
